export const FETCH_EXPERIENCES_REQUEST = 'FETCH_EXPERIENCES_REQUEST';
export const FETCH_EXPERIENCES_SUCCESS = 'FETCH_EXPERIENCES_SUCCESS';
export const FETCH_EXPERIENCES_ERROR = 'FETCH_EXPERIENCES_ERROR';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export const FETCH_EXPERIENCE_REQUEST = 'FETCH_EXPERIENCE_REQUEST';
export const FETCH_EXPERIENCE_SUCCESS = 'FETCH_EXPERIENCE_SUCCESS';
